<div class="loading-bar" #bar>
    <div class="loading-bar__inner"></div>
</div>
